import { render, staticRenderFns } from "./NhomPhanHoiList.vue?vue&type=template&id=12d1a24c&"
import script from "./NhomPhanHoiList.vue?vue&type=script&lang=js&"
export * from "./NhomPhanHoiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports